import OrganisasiAlamat from "./Alamat/OrganisasiAlamat";
import OrganisasiInfo from "./Info/OrganisasiInfo";
import OrganisasiKontak from "./Kontak/OrganisasiKontak";

export default function OrganisasiForm({
	formDataInfo,
	setFormDataInfo,
	showModalLokasi,
	setShowModalLokasi,
	lokasi,
	setLokasi,
	formDataAlamat,
	setFormDataAlamat,
	alamat,
	setAlamat,
	formDataKontak,
	setFormDataKontak,
	telecom,
	setTelecom,
}) {
	return (
		<>
			<OrganisasiInfo
				formDataInfo={formDataInfo}
				setFormDataInfo={setFormDataInfo}
				showModalLokasi={showModalLokasi}
				setShowModalLokasi={setShowModalLokasi}
				lokasi={lokasi}
				setLokasi={setLokasi}
			/>
			<OrganisasiAlamat
				formDataAlamat={formDataAlamat}
				setFormDataAlamat={setFormDataAlamat}
				alamat={alamat}
				setAlamat={setAlamat}
			/>
			<OrganisasiKontak
				formDataKontak={formDataKontak}
				setFormDataKontak={setFormDataKontak}
				telecom={telecom}
				setTelecom={setTelecom}
			/>
		</>
	);
}
